module.exports = __webpack_public_path__ + "static/media/crossIcon.54154d71.svg";